import { FETCH_PORTAL_FEATURED_CATEGORIES } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PORTAL_FEATURED_CATEGORIES:
      return action.payload
    default:
      return state
  }
}
